import { CircularProgress } from "@material-ui/core";
import Button, { ButtonProps } from "@material-ui/core/Button";
import PARCEL_TEMPLATE_HEADER from "config/parcel-template";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { TemplateResultType } from "domains/Job/utils";
import { useCountryCode } from "hooks/useCurrentUser";
import { CountryCode } from "libphonenumber-js";
import React, { useState } from "react";
import { uploadTemplate } from "utils";
import { SeverityType } from "../../contexts/AlertContext";

interface IProps extends ButtonProps {
  onUpload?: (entity: TemplateResultType) => void;
  entityList: any[];
  templateType: string[];
  isloadingFunc?: React.Dispatch<React.SetStateAction<boolean>>;
  parseActionFunc: (
    data: any,
    entityList: any,
    countryCode: CountryCode,
    callback: (entities: any, success: any) => void
  ) => void;
}

function UploadTemplateButton({
  onUpload,
  entityList,
  templateType,
  parseActionFunc,
  isloadingFunc,
  ...props
}: IProps) {
  const [isloading, setLoading] = useState(false);
  const { text } = useText();
  const dispatchAlert = useAlertDispatch();
  const countryCode = useCountryCode();
  const handleChange = (e: any) => {
    e.persist();
    const { files } = e.target;
    if (files && files[0]) {
      setLoading(true);
      isloadingFunc(true);
      const file = files[0];
      uploadTemplate(file, entityList, countryCode, (result, error) => {
        let type: SeverityType;
        let message: string = "";
        if (error) {
          type = "error";
          if (error.message === "header") {
            message = `${text.parcel.upload_failed_file_header_error}: ${PARCEL_TEMPLATE_HEADER.join(", ")}`;
          } else if (error.message === "empty") {
            message = text.parcel.upload_failed_no_parcels;
          } else {
            message = text.all.template_uploading_error;
          }
        } else if (result.count) {
          type = "success";
          onUpload(result);
          message = `${text.parcel.parcel_uploaded_successfully} (${result.newCount} ${text.all.orders})`;
        }
        dispatchAlert({
          message,
          severity: type
        });

        setLoading(false);
        isloadingFunc(false);
      });
      e.target.value = null;
    }
  };

  return (
    <>
      <input accept=".xlsx, .csv" style={{ display: "none" }} id="upload-parcel-button" type="file" onChange={handleChange} />
      <label htmlFor="upload-parcel-button">
        <Button variant="contained" color="primary" component="span" {...props}>
          {isloading ? <CircularProgress /> : `${text.all.upload_template}`}
        </Button>
      </label>
    </>
  );
}

export default UploadTemplateButton;
